import type { BaseFieldStore } from '../Stores/BaseFieldStore'
import { FieldType } from '../Stores/Types/FieldTypeEnum'
import { BaseFieldInputStrategy } from './BaseFieldInputStrategy'

/**
 * Стратегія для checkbox та switch полів
 */
export class CheckboxFieldStrategy extends BaseFieldInputStrategy {
    fieldType: FieldType = FieldType.CHECKBOX

    getValueName(field: BaseFieldStore): string {
        return 'checked'
    }

    transformForView(value: unknown, field: BaseFieldStore): unknown {
        // Якщо є кастомний view
        if (field.isDisableTransform) {
            return super.transformForView(value, field)
        }

        if (typeof field.definition.view === 'function') {
            return field.definition.view(value, field.formContext)
        }

        // Трансформуємо boolean в текст з підтримкою i18n
        // Використовуємо прямий доступ до i18n, оскільки це не React компонент
        const i18nInstance = field.formContext?.i18n || 
            (typeof window !== 'undefined' && window.__I18N_INSTANCE__)
        
        if (i18nInstance && typeof i18nInstance.t === 'function') {
            return value === true ? i18nInstance.t('common.yes') : i18nInstance.t('common.no')
        }
        
        // Fallback до твердо закодованих значень, якщо i18n недоступний
        return value === true ? 'Так' : 'Ні'
    }
}

/**
 * Стратегія для switch (така ж як checkbox)
 */
export class SwitchFieldStrategy extends CheckboxFieldStrategy {
    fieldType: FieldType = FieldType.SWITCH
}
